import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    newqueriesdata:{}
}

const newqueriesSlice = createSlice({
    name: 'newqueries',
    initialState,
    reducers: {
        newqueries: (state, action) => {
            state.newqueriesdata = action.payload
        },
        // Reset the stored query record so a fresh /search-rates visit (e.g. via
        // the top-nav "Search Rates" click) doesn't prefill the air form with a
        // previously opened query's origin/destination/commodity. Without this
        // the record set on a Queries edit/eye action lingers in redux and bleeds
        // a half-filled form into the next fresh search.
        clearnewqueries: (state) => {
            state.newqueriesdata = {}
        }
    }
})
export const { newqueries, clearnewqueries } = newqueriesSlice.actions;
export default newqueriesSlice.reducer